import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getLoginOrSignupPageData } from './api';

/** @knip-ignore */
export const {
	Context: LoginOrSignupPageDataContext,
	Provider: LoginOrSignupPageDataContextProvider,
	useContext: useLoginOrSignupPageData,
	useAsyncData: useLoginOrSignupPageDataFromApi,
	prefetchAsyncData: prefetchLoginOrSignupPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'LoginOrSignupPageDataContext',
	dataProperty: 'pageData',
	getData: getLoginOrSignupPageData,
	errorHandler: pageDataErrorHandler(),
});
